'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _colors = require('../settings/colors');

var _colors2 = _interopRequireDefault(_colors);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var propTypes = {
  color: _propTypes2.default.string
};

var defaultProps = {
  color: _colors2.default.icons
};

var displayName = 'IconLocation';

var IconLocation = function IconLocation(_ref) {
  var color = _ref.color,
      custom = _objectWithoutProperties(_ref, ['color']);

  return _react2.default.createElement(
    'svg',
    _extends({ height: '24', viewBox: '0 0 24 24', width: '24' }, custom),
    _react2.default.createElement('path', { d: 'm11.5392308 4.98276923c-3.15000003 0-5.71153849 2.56223077-5.71153849 5.71223077 0 2.4313846 3.78 6.3366923 5.71153849 8.0778462 1.9315384-1.7411539 5.7115384-5.6464616 5.7115384-8.0778462 0-3.15-2.5615384-5.71223077-5.7115384-5.71223077zm0 15.40384617c-.1592308 0-.3184616-.0546923-.45-.1654616-.6784616-.5801538-6.64615388-5.775923-6.64615388-9.5261538 0-3.91292308 3.18461539-7.09684615 7.09615388-7.09684615 3.9115384 0 7.0961538 3.18392307 7.0961538 7.09684615 0 3.7502308-5.9676923 8.946-6.6461538 9.5261538-.1315385.1107693-.2907693.1654616-.45.1654616z', fill: color }),
    ' ',
    _react2.default.createElement('path', { d: 'm11.5392308 8.61807692c-1.1423077 0-2.07692311.93184616-2.07692311 2.07692308 0 1.1457692.93461541 2.0769231 2.07692311 2.0769231s2.076923-.9311539 2.076923-2.0769231c0-1.14507692-.9346153-2.07692308-2.076923-2.07692308zm0 5.53846158c-1.91076926 0-3.46153849-1.5528462-3.46153849-3.4615385 0-1.90869231 1.55076923-3.46153846 3.46153849-3.46153846 1.9107692 0 3.4615384 1.55284615 3.4615384 3.46153846 0 1.9086923-1.5507692 3.4615385-3.4615384 3.4615385z', fill: color }),
    ' '
  );
};

IconLocation.propTypes = propTypes;
IconLocation.defaultProps = defaultProps;
IconLocation.displayName = displayName;

exports.default = IconLocation;
module.exports = exports.default;